<template>
  <div class="mobile_wrap">
    <!-- 切页内容 -->
    <swiper
      class="page_slider"
      :modules="[Lazy]"
      :direction="'vertical'"
      :resistanceRatio="0"
      :lazy="{ loadPrevNext: true, loadOnTransitionStart: true }"
      :preloadImages="false"
      :speed="500"
      @swiper="onSwiper"
      @slideChangeTransitionEnd="onSlideChange"
      @init="onSwiperInit"
    >
      <!-- 首页 -->
      <swiper-slide class="page page1">
        <div class="page_video">
          <div
            ref="wrapper"
            class="video-wrapper"
            :style="hdVidLoading ? 'opacity: 0;' : 'opacity: 1;'"
          ></div>
        </div>
        <div class="top_mask pa"></div>
        <div class="center_content">
          <!-- <a href="javascript:;" class="btn_vid pa" @click="showVideo()"></a> -->
          <div class="slogan pa">
            <img class="swiper-lazy" :src="slgSrc" alt="" />
          </div>
          <a
            href="javascript:;"
            class="btn_order pa"
            @click="appointment()"
            v-if="!reservationStatus"
            >立即预约</a
          >
          <a href="javascript:;" class="btn_order pa" v-else>已预约</a>
          <div class="order_bum pa">
            全平台预约人数: <span>{{ mileNum }}</span>
          </div>
        </div>
        <div class="scroll_icon pa"></div>
        <div
          class="age_icon pa"
          @click="
            () => {
              homeOnAgeTipsClickReporting();
              popSl = true;
            }
          "
        ></div>
        <!-- <a
          class="hd_link pa"
          target="_blank"
          :href="getGithubUrl()"
          @click="homeOnOfficialSiteClickReporting()"
        ></a> -->
      </swiper-slide>
      <!-- 角色 -->
      <swiper-slide class="page page2">
        <div class="center_content">
          <!-- 角色内容 -->
          <div class="rw_con">
            <template
              v-for="(character, characterIndex) in characterData"
              :key="character.id"
            >
              <div
                :class="`rw_box rw_box${
                  character.id === 4 || character.id === 5 ? '4' : character.id
                }`"
                v-show="jsnum === characterIndex"
              >
                <!-- 角色立绘 -->
                <div class="rw_lihui">
                  <img
                    :src="character.image"
                    alt=""
                    class="rw_img swiper-lazy"
                  />
                </div>
                <!-- 角色文案-->
                <div class="rw_left">
                  <template
                    v-for="(typeData, typeIndex) in character.descriptions"
                    :key="typeIndex"
                  >
                    <div class="rw_info" v-if="jstype === typeIndex + 1">
                      <div class="rw_name">
                        <img
                          class="swiper-lazy"
                          :src="character.names[typeIndex]"
                          alt=""
                        />
                      </div>
                      <div
                        :class="
                          character.showTxtStates[typeIndex]
                            ? 'rw_txt hastxtbg'
                            : 'rw_txt'
                        "
                      >
                        <p class="r_txts r_txts1" v-html="typeData[0]"></p>
                        <a
                          href="javascript:;"
                          class="toggle_txt"
                          @click="character.showTxtStates[typeIndex] = true"
                          v-if="!character.showTxtStates[typeIndex]"
                          >展开</a
                        >
                        <p
                          class="r_txts r_txts2"
                          v-if="character.showTxtStates[typeIndex]"
                        >
                          <span v-html="typeData[1]"></span
                          ><a
                            href="javascript:;"
                            class="toggle_txt"
                            @click="character.showTxtStates[typeIndex] = false"
                            >收起</a
                          >
                        </p>
                      </div>
                    </div>
                  </template>
                  <!-- 切换 颂灵者/使灵 -->
                  <div class="rw_tab1">
                    <a
                      href="javascript:;"
                      :class="jstype == 1 ? 'tab1 db cur' : 'tab1 db'"
                      @click="jstype = 1"
                      >颂灵者</a
                    >
                    <a
                      href="javascript:;"
                      :class="jstype == 2 ? 'tab2 db cur' : 'tab2 db'"
                      @click="jstype = 2"
                      >使灵</a
                    >
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- 右侧切换颂灵者角色 -->
          <div class="rw_tab2">
            <swiper
              class="rw_tabslider"
              :slidesPerView="3"
              :loop="true"
              :centeredSlides="true"
              :allow-touch-move="false"
              @swiper="onSwiper3"
              @slideChange="onSlideChange3"
            >
              <swiper-slide
                v-for="character in characterData"
                :key="character.id"
              >
                <div class="tx_img">
                  <img
                    :class="character.id === 1 ? 'swiper-lazy' : ''"
                    :src="character.iconImages[jstype - 1]"
                    alt=""
                  />
                  <a
                    href="javascript:;"
                    class="rwtab_prev"
                    @click="goToPrev()"
                  ></a>
                  <a
                    href="javascript:;"
                    class="rwtab_next"
                    @click="goToNext()"
                  ></a>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </swiper-slide>
      <!-- 地图 -->
      <swiper-slide class="page page3">
        <div class="top_mask pa"></div>
        <div class="bottom_mask pa"></div>
        <div class="map_con">
          <div class="map_box" v-show="mapNum == 1">
            <div class="map_video" ref="mapVid1"></div>
            <img
              src="/img/pc/map_txt2.png"
              alt=""
              class="map_txt swiper-lazy"
            />
          </div>
          <div class="map_box" v-show="mapNum == 2">
            <div class="map_video" ref="mapVid2"></div>
            <img
              src="/img/pc/map_txt1.png"
              alt=""
              class="map_txt swiper-lazy"
            />
          </div>
          <div class="map_box" v-show="mapNum == 3">
            <div class="map_video" ref="mapVid3"></div>
            <img
              src="/img/pc/map_txt3.png"
              alt=""
              class="map_txt swiper-lazy"
            />
          </div>
          <div class="map_box" v-show="mapNum == 4">
            <div class="map_video" ref="mapVid4"></div>
            <img
              src="/img/pc/map_txt4.png"
              alt=""
              class="map_txt swiper-lazy"
            />
          </div>
          <div class="map_box" v-show="mapNum == 5">
            <div class="map_video" ref="mapVid5"></div>
            <img
              src="/img/pc/map_txt5.png"
              alt=""
              class="map_txt swiper-lazy"
            />
          </div>
        </div>
        <div class="map_tab">
          <swiper
            class="map_slider"
            :slidesPerView="5"
            :loop="true"
            :centeredSlides="true"
            :allow-touch-move="false"
            @swiper="onSwiper4"
            @slideChange="onSlideChange4"
          >
            <template v-for="(mapData, index) in mapList" :key="mapData.id">
              <swiper-slide>
                <div class="map_click">
                  <p class="map_name">{{ mapData.name }}</p>
                  <div class="map_icon"></div>
                  <a
                    href="javascript:;"
                    class="map_prev"
                    @click="mapPrev()"
                  ></a>
                  <a
                    href="javascript:;"
                    class="map_next"
                    @click="mapNext()"
                  ></a>
                  <a href="javascript:;" class="map_to"></a>
                </div>
              </swiper-slide>
            </template>
          </swiper>
        </div>
      </swiper-slide>
      <!-- 资讯 -->
      <swiper-slide class="page page4">
        <div class="news_page">
          <div class="center_content">
            <div class="news_swiper">
              <swiper
                class="news_slider"
                :autoplay="showNews ? { delay: 4000 } : false"
                :pagination="{ clickable: true }"
                @swiper="onSwiper2"
                @slideChange="onSlideChange2"
              >
                <template v-for="(item, index) in newsList" :key="index">
                  <swiper-slide>
                    <div
                      class="news_lb"
                      @click="$router.push('/news?id=' + item.id)"
                    >
                      <img :src="item.broadcast_image" alt="" />
                    </div>
                  </swiper-slide>
                </template>
              </swiper>
              <div class="news_pages">
                <em>{{ newsCurrent < 10 ? "0" + newsCurrent : newsCurrent }}</em
                >/<span>{{
                  newsList.length < 10 ? "0" + newsList.length : newsList.length
                }}</span>
              </div>
            </div>
            <div class="news_content">
              <div class="news_tab">
                <a
                  href="javascript:;"
                  :class="newsType == 0 ? 'cur' : ''"
                  @click="changeNewsType(0)"
                  >最新</a
                >
                <a
                  href="javascript:;"
                  :class="newsType == 1 ? 'cur' : ''"
                  @click="changeNewsType(1)"
                  >新闻</a
                >
                <a
                  href="javascript:;"
                  :class="newsType == 2 ? 'cur' : ''"
                  @click="changeNewsType(2)"
                  >公告</a
                >
                <a
                  href="javascript:;"
                  :class="newsType == 3 ? 'cur' : ''"
                  @click="changeNewsType(3)"
                  >活动</a
                >
              </div>
              <ul class="news_list" v-if="newsList2">
                <template v-for="(item, index) in newsList2" :key="index">
                  <li @click="$router.push('/news?id=' + item.id)">
                    <p class="news_time">{{ formatDate(item.start_time) }}</p>
                    <p class="news_txt">
                      <em>{{ newsTypeText[item.type] }}</em
                      ><span>{{ item.title }}</span>
                    </p>
                  </li>
                </template>
              </ul>
              <div class="news_none" v-else>暂无更多内容</div>
              <a
                href="javascript:;"
                class="btn_more db"
                v-if="newsList"
                @click="$router.push('/mobile/list')"
                >查看更多</a
              >
            </div>
          </div>
        </div>
        <!-- 底部版权 -->
        <div class="copyright_box">
          <img
            src="/img/pc/footer_logo.png"
            alt=""
            class="footer_logo swiper-lazy"
          />
          <img src="/img/pc/logo-white.png" alt="" class="logo_white" />
          <div class="copyright_right">
            <div class="copyright_link">
              <a
                href="https://rule.sarosgame.com/sarosis/20250609/l6/tos.html"
                target="_blank"
                >服务协议</a
              >
              |
              <a
                href="https://rule.sarosgame.com/sarosis/20250609/l6/pp.html"
                target="_blank"
                >个人信息保护规则</a
              >
              |
              <a
                href="https://rule.sarosgame.com/sarosis/20241112/coppa.html"
                target="_blank"
                >儿童个人信息保护规则</a
              >
              <br />
              <span>联系我们 15958032334</span> <br />
              <span>版权所有 © 2025 萨罗斯网络科技（深圳）有限公司</span><br />
              <span
                >联系地址：深圳市前海深港合作区南山街道梦海大道5033号卓越前海壹号T3
                L9-01</span
              ><br />
              <a href="https://beian.miit.gov.cn/" target="_blank" v-if="hasUrl"
                >粤ICP备2024185500号-1</a
              >
              <a href="https://beian.miit.gov.cn/" target="_blank" v-else
                >粤ICP备2024185500号-3</a
              >
              <span v-show="hasUrl">
                |
                <a
                  href="https://beian.mps.gov.cn/#/query/webSearch"
                  target="_blank"
                  >粤公网安备44030002005143</a
                >
              </span>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!-- 顶部 -->
    <div class="top_box">
      <a href="javascript:;" class="top_logo" v-if="navNum == 0"></a>
      <a
        href="javascript:;"
        class="show_nav"
        v-else
        @click="showNav = true"
      ></a>
      <div class="tright_icon">
        <div class="user_info" v-if="isLogin">
          <img :src="userImgUrl" alt="" class="user_img" />
          <span>已经登录</span>
          <a href="javascript:;" class="btn_logout" @click="logout()">登出</a>
        </div>
        <a href="javascript:;" class="btn_login" @click="login()" v-else></a>
        <a
          href="javascript:;"
          :class="bgmState ? 'btn_bgm play' : 'btn_bgm'"
          @click="playBgm()"
        ></a>
        <a href="javascript:;" class="btn_zhuan" @click="showShare()"></a>
      </div>

      <!-- 新增适龄弹窗 -->
      <div class="pop_mask" v-if="popSl">
        <div class="pop_content pop_sl">
          <div class="pop_info">
            <div class="login_title">适龄提示</div>
            <ul class="sl_txt">
              <li>
                1.本游戏是一款开放世界动作类游戏，适用于年满16周岁以上的用户，建议未成年人在监护人的监护下使用游戏产品。
              </li>
              <li>
                2.本游戏基于架空世界展开剧情，采用风格鲜明的美术设计、精美的游戏画面，优质的游戏配乐以及新颖的系统玩法。
              </li>
              <li>
                3.本游戏中有用户实名认证系统，认证为未成年的用户将受到以下游戏的限制：<br />
                未满8周岁的用户不能充值；8周岁以上未满16周岁的未成年用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币；16周岁以上的未成年用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。<br />
                游戏仅会在周五、周六、周日和法定节假日的20时至21时，向未成年人提供1小时游戏服务。
              </li>
              <li>
                4.本游戏设置了主线、支线剧情，通过对话与交互推动剧情，游戏还提供了开放世界探索玩法。游戏内提供了少量基于文字的陌生人社交系统，该社交系统遵循相关法律法规进行管理。
              </li>
            </ul>
          </div>
          <a href="javascript:;" @click="popSl = false" class="pop_close db"
            >关闭</a
          >
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div class="nav_pop" v-if="showNav">
      <ul class="nav_list">
        <li :class="navNum == 0 ? 'cur' : ''" @click="goToSlide(0)">首页</li>
        <li :class="navNum == 1 ? 'cur' : ''" @click="goToSlide(1)">角色</li>
        <li :class="navNum == 2 ? 'cur' : ''" @click="goToSlide(2)">地图</li>
        <li :class="navNum == 3 ? 'cur' : ''" @click="goToSlide(3)">资讯</li>
      </ul>
      <!-- <div class="rbottom pa">
        <div class="rbottom_icon">
          <a
            href="javascript:;"
            class="ricon1 db"
            @click="
              () => {
                wxPop = true;
                homeOnOfficialMediaClickReporting(1);
              }
            "
          ></a>
          <a
            href="https://weibo.com/u/7947701804"
            target="_blank"
            class="ricon2 db"
            @click="homeOnOfficialMediaClickReporting(2)"
          ></a>
          <a
            href="https://l.taptap.cn/QEnaLNZi?channel=rep-rep_bemummkj8nj"
            class="ricon3 db"
            @click="homeOnOfficialMediaClickReporting(3)"
          ></a>
          <a
            href="https://space.bilibili.com/3546757206116480"
            target="_blank"
            class="ricon4 db"
            @click="homeOnOfficialMediaClickReporting(4)"
          ></a>
          <a
            href="javascript:;"
            class="ricon5 db"
            @click="
              () => {
                qqPop = true;
                homeOnOfficialMediaClickReporting(5);
              }
            "
          ></a>
        </div>
      </div> -->
      <a href="javascript:;" class="close_nav" @click="showNav = false"></a>
    </div>
    <!-- 视频 -->
    <div class="pop_bg" v-if="popVideo">
      <div class="video_box">
        <!-- <video
          :src="vidUrl"
          x5-video-player-type="h5"
          webkit-playsinline="true"
          playsinline="true"
          controls
          crossorigin="anonymous"
          preload="auto"
        ></video> -->
        <iframe
          src="https://player.bilibili.com/player.html?isOutside=true&aid=114646937769853&bvid=BV1crTXzDE8r&cid=30366041181&p=1"
          scrolling="no"
          border="0"
          frameborder="no"
          framespacing="0"
          allowfullscreen="true"
          width="100%"
          height="100%"
        ></iframe>
        <a href="javascript:;" class="pop_close db" @click="hideVideo()"
          >关闭</a
        >
      </div>
    </div>

    <!-- qq扫码弹窗 -->
    <div class="pop_bg" v-if="qqPop">
      <div class="wx_img">
        <img src="/img/pc/pop_qq.jpg" alt="" />
        <a href="javascript:;" class="pop_close db" @click="qqPop = false"
          >关闭</a
        >
      </div>
    </div>
    <!-- 微信扫码弹窗 -->
    <div class="pop_bg" v-if="wxPop">
      <div class="wx_img">
        <img src="/img/pc/wx.jpg" alt="" />
        <a href="javascript:;" class="pop_close db" @click="wxPop = false"
          >关闭</a
        >
      </div>
    </div>

    <!-- 预约弹窗 -->
    <Order
      :visible="showOrder"
      @close="
        () => {
          getReservationStatus();
          showOrder = false;
        }
      "
    />

    <!-- 登录弹窗 -->
    <Login
      :visible="showLogin"
      @close="showLogin = false"
      @handle="
        () => {
          showLogin = false;
          copyPop = true;
        }
      "
    />

    <!-- 分享浮层 -->
    <div class="share_pop" @click="closeShare()" v-if="sharePop">
      <img src="/img/m/share_fc.png" alt="" />
    </div>

    <!-- bgm -->
    <audio src="media/bgm.mp3" loop preload="auto" autoplay class="bgm"></audio>
    <!-- 地图点击音 -->
    <audio
      src="media/map_click.mp3"
      class="map_clickbgm"
      :muted="!bgmState"
      id="map_clickbgm"
    ></audio>
    <!-- 地图背景乐 -->
    <audio
      :src="mapSrc"
      :muted="!bgmState"
      id="map_bgms"
      loop
      preload="auto"
    ></audio>

    <!-- 新增弹窗复制链接 -->
    <div class="pop_bg" v-if="copyPop">
      <div class="copy_pop">
        <div>
          <p class="copy_tips">复制以下链接至微信打开</p>
          <input type="text" :value="webUrl" class="copy_input" readonly />
          <a href="javascript:;" class="copy_btn" @click="copyLink()">复制</a>
          <p class="copy_tips">或用微信扫描下方活动二维码</p>
          <div class="ewm_box">
            <img :src="qrImage" alt="" />
          </div>
        </div>
        <a href="javascript:;" class="pop_close db" @click="copyPop = false"
          >关闭</a
        >
      </div>
    </div>

    <!-- 新增适龄弹窗 -->
    <div class="pop_mask" v-if="popSl">
      <div class="pop_content pop_sl">
        <div class="pop_info">
          <div class="login_title">适龄提示</div>
          <ul class="sl_txt">
            <li>
              1.本游戏是一款开放世界动作类游戏，适用于年满16周岁以上的用户，建议未成年人在监护人的监护下使用游戏产品。
            </li>
            <li>
              2.本游戏基于架空世界展开剧情，采用风格鲜明的美术设计、精美的游戏画面，优质的游戏配乐以及新颖的系统玩法。
            </li>
            <li>
              3.本游戏中有用户实名认证系统，认证为未成年的用户将受到以下游戏的限制：<br />
              未满8周岁的用户不能充值；8周岁以上未满16周岁的未成年用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币；16周岁以上的未成年用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。<br />
              游戏仅会在周五、周六、周日和法定节假日的20时至21时，向未成年人提供1小时游戏服务。
            </li>
            <li>
              4.本游戏设置了主线、支线剧情，通过对话与交互推动剧情，游戏还提供了开放世界探索玩法。游戏内提供了少量基于文字的陌生人社交系统，该社交系统遵循相关法律法规进行管理。
            </li>
          </ul>
        </div>
        <a href="javascript:;" @click="popSl = false" class="pop_close db"
          >关闭</a
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  homeOnOfficialMediaClickReporting,
  homeOnOfficialSiteClickReporting,
  homeOnAgeTipsClickReporting,
  homeOnOfficialMediaAppointClickReporting,
  homeOnPlayClickReporting,
  homeOnMapClickReporting,
  homeOnRoleClickReporting,
} from "@/utils/reporting";
import {
  getToken,
  removeToken,
  openWxLogin,
  openQqLogin,
  getHeadImg,
} from "@/utils/qwLogin";
import {
  isInWeChatWork,
  isInQQWork,
  generateQRCode,
  getGithubUrl,
} from "@/utils"; // 判断是否在微信工作台
import {
  ref,
  onMounted,
  onUnmounted,
  watch,
  onBeforeUnmount,
  reactive,
  nextTick,
  computed,
} from "vue"; // 导入vue
import { useRoute, useRouter } from "vue-router"; // 导入 useRouter
import { Swiper, SwiperSlide } from "swiper/vue"; // 引入 Swiper
import { Lazy } from "swiper";
import "swiper/css"; // 引入样式
import "swiper/css/lazy";
import "swiper/css/pagination"; // 引入分页器样式
import SwiperCore, { Mousewheel, Autoplay, Pagination } from "swiper";
import Order from "@/components/Order.vue"; // 引入弹窗组件
import Login from "@/components/Login.vue"; // 引入弹窗组件
import { formatDate } from "@/utils/formatDate"; // 导入时间格式化函数
import {
  getCode,
  makeReservation,
  getNewsList,
  getNewsDetail,
  getMilestone,
  getReservation,
} from "@/api"; // 导入api
import { toast } from "vue3-toastify"; // 引入toast组件
import JSMpeg from "@cycjimmy/jsmpeg-player"; // 引入jsmpeg播放器,首页自动播放
import { mobileCharacterData } from "@/config/characterData";
SwiperCore.use([Mousewheel, Autoplay, Pagination]);
const hasUrl = window.location.host.includes("sarosgame.com");
// 整个页面的Swiper实例
const mySwiper = ref(null); // 定义一个ref来保存Swiper实例
const qqPop = ref(false); // 定义一个ref来保存qq扫码弹窗状态
const qrImage = ref("");
const wxPop = ref(false); // 定义一个ref来保存微信扫码弹窗状态
const copyPop = ref(false); // 定义一个ref来保存复制链接弹窗状态
const popSl = ref(false); // 定义一个ref来保存适龄提示弹窗状态
const webUrl = window.location.href;

// 设置html和body的高度为100%
document.documentElement.style.height = "100%";
document.body.style.height = "100%";

// 首页视频
const wrapper = ref(null); // 首页视频容器
const hdVidLoading = ref(true); // 首页视频加载状态
let player = null; // 首页视频播放器实例

// 地图页视频 - 统一管理
const mapVideoRefs = [
  ref(null), // mapVid1
  ref(null), // mapVid2
  ref(null), // mapVid3
  ref(null), // mapVid4
  ref(null), // mapVid5
];
const mapVid1 = mapVideoRefs[0];
const mapVid2 = mapVideoRefs[1];
const mapVid3 = mapVideoRefs[2];
const mapVid4 = mapVideoRefs[3];
const mapVid5 = mapVideoRefs[4];

let mapPlayers = []; // 地图视频播放器数组

// 视频配置
const videoConfig = {
  autoplay: false,
  loop: true,
  disableGl: true,
  progressive: true,
  preserveDrawingBuffer: true,
  decodeFirstFrame: true,
};

const videoOptions = {
  audio: false,
};

// 创建视频播放器的统一方法
const createVideoPlayer = (
  container,
  source,
  config = videoConfig,
  options = videoOptions
) => {
  return new JSMpeg.VideoElement(container, source, config, options);
};

// 初始化所有视频播放器
const initVideoPlayers = () => {
  // 初始化首页视频
  player = createVideoPlayer(
    wrapper.value,
    "media/cg2.ts",
    { ...videoConfig, autoplay: true },
    {
      ...videoOptions,
      onPlay: () => {
        hdVidLoading.value = false;
      },
    }
  );

  // 使用mapList配置初始化地图视频播放器
  mapPlayers = mapVideoRefs
    .map((ref, index) => {
      if (ref.value && mapList[index]) {
        return createVideoPlayer(ref.value, mapList[index].videoSource);
      }
      return null;
    })
    .filter((player) => player !== null);
};

// 销毁所有视频播放器
const destroyVideoPlayers = () => {
  if (player) {
    player.destroy();
    player = null;
  }

  mapPlayers.forEach((mapPlayer) => {
    if (mapPlayer) {
      mapPlayer.destroy();
    }
  });
  mapPlayers = [];
};

onMounted(() => {
  initVideoPlayers();
});

onBeforeUnmount(() => {
  destroyVideoPlayers();
});
// mapPlayer1.player.play();   // 播放
// player.player.pause();  // 暂停

// 提示文案
function showToast(msg) {
  toast.info(msg);
}

// 导航显示状态
const showNav = ref(false);

// 弹窗状态
const showOrder = ref(false); // 预约弹窗
const showLogin = ref(false); // 登录弹窗

// 双端适配
const router = useRouter(); // 获取路由实例
const isPt = () => {
  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  if (isMobile) {
    router.push("/mobile");
  } else {
    router.push("/");
  }
};
onMounted(() => {
  isPt();
  setTimeout(() => {
    document.dispatchEvent(new Event("render-event"));
  });
  window.addEventListener("resize", isPt);
});
onUnmounted(() => {
  window.removeEventListener("resize", isPt);
});

// bgm播放
const bgmState = ref(false); // 定义一个ref来保存bgm播放状态
// const pageClick = ref(false); // 定义一个ref来保存是否点击过页面
let allbgm = document.querySelector(".bgm"); // 定义一个bgm对象
let mapBgm = document.getElementById("map_bgms");
onMounted(() => {
  allbgm = document.querySelector(".bgm"); // 定义一个bgm对象
  mapBgm = document.getElementById("map_bgms");
  bgmPlay();
  document.addEventListener("WeixinJSBridgeReady", function () {
    bgmPlay();
  });
});
function bgmPlay() {
  allbgm.play(); // 进入页面播放
  mapSoundControl(mapNum.value);
  setTimeout(() => {
    mapSoundControl(0);
  }, 200);
  bgmState.value = true;
}
const playBgm = () => {
  if (bgmState.value) {
    allbgm.pause();
    bgmState.value = false;
    mapSoundControl(0); // 地图页音效关闭
  } else {
    allbgm.play();
    bgmState.value = true;
    if (mySwiper.value.activeIndex == 2) {
      //如果是在地图页面，则恢复地图页声音
      mapSoundControl(mapNum.value); // 地图页音效开启
    } else {
      mapSoundControl(0); // 地图页音效关闭
    }
  }
};
document.body.addEventListener(
  "click",
  () => {
    if (!popVideo.value) {
      if (mySwiper.value.activeIndex == 2) {
        //如果是在地图页面，则恢复地图页声音
        // mapBgm.play();
        mapSoundControl(mapNum.value); // 地图页音效开启
      }
      allbgm.play(); // 进入页面播放
      bgmState.value = true;
    }
    // pageClick.value = true;
  },
  { once: true }
);

// 控制地图视频声音
const mapSrc = ref("media/map1.mp3"); // 定义一个ref来保存当前地图的索引
const mapSoundControl = (n) => {
  if (n == 0) {
    mapBgm.pause();
  } else {
    // 使用mapList配置中的音频地址
    const mapData = mapList.find((item) => item.id === n);
    if (mapData) {
      mapSrc.value = mapData.audioSource;
      setTimeout(() => {
        mapBgm.play();
      }, 100);
    }
  }
};

// 预约数量
const mileNum = ref(0); // 定义一个ref来保存预约数量
onMounted(async () => {
  try {
    // 获取新闻列表
    const res = await getMilestone();
    mileNum.value = res.total;
    // console.log(res.total);
  } catch (e) {
    console.warn(e);
  }
});

// Swiper新闻
const newsList = ref([]); // 初始为空数组
const newsList2 = ref([]); // 初始为空数组
onMounted(async () => {
  try {
    // 获取新闻列表
    const res = await getNewsList(1, 4);
    newsList.value = res.list;
    newsList2.value = res.list;
  } catch (e) {
    console.warn(e);
  }
});
const newsCurrent = ref(0); // 定义一个ref来保存当前新闻的索引
const mySwiper2 = ref(null); // 定义一个ref来保存Swiper实例
const onSwiper2 = (swiper2) => {
  mySwiper2.value = swiper2;
  newsCurrent.value = mySwiper2.value.activeIndex + 1;
};
const onSlideChange2 = () => {
  if (mySwiper2.value) {
    // 增加空值检查
    // console.log(mySwiper2.value.activeIndex);
    newsCurrent.value = mySwiper2.value.activeIndex + 1;
  }
};
// 切换新闻类型
const newsType = ref(0); // 定义一个ref来保存当前新闻类型
const newsTypeText = ["最新", "新闻", "公告", "活动"]; // 定义新闻类型文本
const changeNewsType = (type) => {
  //切换新闻类型，只显示对应type的新闻
  newsType.value = type;
  //重新请求新闻列表
  getNewsList(1, 4, type).then((res) => {
    // console.log("当前获取的type内容：",res)
    newsList2.value = res.list;
  });
};

// 地图数据配置
const mapList = [
  {
    id: 1,
    name: "洛伦城",
    ref: "mapVid1",
    txtImage: "/img/pc/map_txt2.png",
    videoSource: "media/map2_m.ts",
    audioSource: "media/map1.mp3",
  },
  {
    id: 2,
    name: "智思海",
    ref: "mapVid2",
    txtImage: "/img/pc/map_txt1.png",
    videoSource: "media/map1_m.ts",
    audioSource: "media/map2.mp3",
  },
  {
    id: 3,
    name: "夕影村",
    ref: "mapVid3",
    txtImage: "/img/pc/map_txt3.png",
    videoSource: "media/map3_m.ts",
    audioSource: "media/map3.mp3",
  },
  {
    id: 4,
    name: "黄昏",
    ref: "mapVid4",
    txtImage: "/img/pc/map_txt5.png",
    videoSource: "media/map5_m.ts",
    audioSource: "media/map5.mp3",
  },
  //   {
  //   id: 4,
  //   name: '断罪高塔',
  //   ref: 'mapVid4',
  //   txtImage: '/img/pc/map_txt4.png',
  //   videoSource: 'media/map4_m.ts',
  //   audioSource: 'media/map4.mp3'
  // },
];

// 地图部分轮播
const mySwiper4 = ref(null); // 定义一个ref来保存Swiper实例
const mapNum = ref(1); // 定义一个ref来保存当前地图的索引
const onSwiper4 = (swiper4) => {
  mySwiper4.value = swiper4;
};
// 统一的地图视频控制方法
const controlMapVideo = (activeIndex) => {
  // 暂停所有地图视频
  mapPlayers.forEach((player) => {
    if (player && player.player) {
      player.player.pause();
    }
  });

  // 播放当前激活的视频
  if (activeIndex >= 1 && activeIndex <= 5) {
    const currentPlayer = mapPlayers[activeIndex - 1];
    if (currentPlayer && currentPlayer.player) {
      setTimeout(() => {
        currentPlayer.player.play();
        mapSoundControl(activeIndex);
      }, 100);
    }
  }
};

const onSlideChange4 = () => {
  if (mySwiper4.value) {
    mapNum.value = mySwiper4.value.realIndex + 1;
    controlMapVideo(mapNum.value);
    homeOnMapClickReporting(mapNum.value);
  }
};
// Swiper切屏
const showNews = ref(false); // 定义一个ref来保存是否显示新闻
const navNum = ref(0); // 定义一个ref来保存当前导航的索引
// SwiperCore.use([Mousewheel,Autoplay ]);
const slgSrc = ref("img/m/slogan.png");
const onSwiper = (swiper) => {
  mySwiper.value = swiper;
  slgSrc.value = "img/m/slogan.png?d" + Date.now();
  // goToSlide(2); // 测试用
};
const onSlideChange = () => {
  const activeIndex = mySwiper.value.activeIndex;

  // 首页视频控制
  if (activeIndex === 0) {
    slgSrc.value = "img/m/slogan.png?d" + Date.now();
    if (player && player.player) {
      player.player.play();
    }
  } else {
    if (player && player.player) {
      player.player.pause();
    }
  }

  // 地图页视频控制
  if (activeIndex === 2) {
    controlMapVideo(mapNum.value);
  } else {
    // 暂停所有地图视频
    mapPlayers.forEach((mapPlayer) => {
      if (mapPlayer && mapPlayer.player) {
        mapPlayer.player.pause();
      }
    });

    if (bgmState.value) {
      document.querySelector(".bgm").play();
    }
    mapSoundControl(0);
  }

  // 新闻页控制
  showNews.value = activeIndex === 3;

  navNum.value = activeIndex;

  // 防止快速切换
  document.documentElement.style.pointerEvents = "none";
  setTimeout(() => {
    document.documentElement.style.pointerEvents = "auto";
  }, 350);
};
// 提前加载
function onSwiperInit(swiper) {
  // 等待一帧再懒加载，避免第一次卡顿
  // console.log(swiper.activeIndex)
  setTimeout(() => {
    swiper.lazy.loadInSlide(swiper.activeIndex);
    swiper.lazy.loadInSlide(swiper.activeIndex + 3);
  }, 30);
}
onMounted(() => {
  // 最后一屏滑动
  const scrollArea = document.querySelector(".page4");
  let startY = 0;

  scrollArea.addEventListener(
    "touchstart",
    (e) => {
      startY = e.touches[0].clientY;
    },
    { passive: false }
  );

  scrollArea.addEventListener(
    "touchmove",
    (e) => {
      // 新增判断：如果触摸点在轮播图内则直接返回
      if (e.target.closest(".news_swiper")) {
        mySwiper.value.allowTouchMove = true; // 确保轮播触摸可用
        return;
      }

      const el = e.currentTarget;
      const currentY = e.touches[0].clientY;
      const deltaY = currentY - startY;
      const atTop = el.scrollTop === 0;
      const atBottom = el.scrollHeight - el.scrollTop === el.clientHeight;

      // 向下滑动（手指向下移动）
      if (deltaY < 0 && !atBottom) {
        // console.log('向下滑动查看底部版权');
        el.scrollTop = el.scrollHeight - el.clientHeight;
        e.preventDefault();
        mySwiper.value.allowTouchMove = false;
      }
      // 向上滑动（手指向上移动）
      else if (deltaY > 0 && !atTop) {
        if (el.scrollTop > 0) {
          // console.log('向上滑动查看顶部');
          el.scrollTop = 0;
          e.preventDefault();
        }
      } else {
        mySwiper.value.allowTouchMove = true;
      }
      startY = currentY;
    },
    { passive: false }
  );
});

// 跳指定页
const goToSlide = (index) => {
  // console.log(index)
  if (mySwiper.value) {
    mySwiper.value.slideTo(index);
    showNav.value = false;
  }
};

// 左2和右2的地图icon点击事件
const mapNext = () => {
  mySwiper4.value.update();
  mySwiper4.value.slideNext();
  document.getElementById("map_clickbgm").play();
};
const mapPrev = () => {
  mySwiper4.value.update();
  mySwiper4.value.slidePrev();
  document.getElementById("map_clickbgm").play();
};
// 给最左和最右的地图icon添加点击事件
onMounted(() => {
  document.querySelectorAll(".map_to").forEach((item) => {
    item.addEventListener("click", function () {
      const currentSlide = this.closest(".swiper-slide");
      const prevSlide = currentSlide?.previousElementSibling;

      if (prevSlide?.classList.contains("swiper-slide-next")) {
        // console.log('命中前一个是 swiper-slide-next');
        mySwiper4.value.slideNext(0);
        mySwiper4.value.slideNext();
      } else {
        // console.log('命中前一个不是 swiper-slide-next');
        mySwiper4.value.slidePrev(0);
        mySwiper4.value.slidePrev();
      }
      document.getElementById("map_clickbgm").play();
    });
  });
});

// 点击弹窗视频并且播放
const popVideo = ref(false);
const vidUrl = ref("media/cgm.mp4"); // 定义一个ref来保存视频地址
const showVideo = () => {
  homeOnPlayClickReporting();
  popVideo.value = true;
  allbgm.pause();
  // setTimeout(() => {
  // document.querySelector(".video_box video").play();
  // }, 100);
};
const hideVideo = () => {
  popVideo.value = false;
  // document.querySelector(".video_box video").pause();
  if (bgmState.value) {
    allbgm.play();
  }
};

// 点击弹出分享指引
const sharePop = ref(false);
const showShare = () => {
  sharePop.value = true;
};
const closeShare = () => {
  sharePop.value = false;
};

//角色部分
const jsnum = ref(0); // 当前角色在数组中的索引 (0-based)
const jstype = ref(1); // 角色1的两种属性索引

// 移动端角色数据配置
const characterData = ref(mobileCharacterData);
// 角色切换swiper
const mySwiper3 = ref(null); // 定义一个ref来保存Swiper实例
const onSwiper3 = (swiper3) => {
  mySwiper3.value = swiper3;
};
const onSlideChange3 = () => {
  if (mySwiper3.value) {
    // 增加空值检查
    jsnum.value = mySwiper3.value.realIndex;
    const currentCharacter = characterData.value[jsnum.value];
    if (currentCharacter) {
      homeOnRoleClickReporting(currentCharacter.id);
    }
  }
};
const goToNext = () => {
  mySwiper3.value.update();
  mySwiper3.value.slideNext();
};
const goToPrev = () => {
  mySwiper3.value.update();
  mySwiper3.value.slidePrev();
};

// 复制链接
const copyLink = () => {
  const link = webUrl;
  const input = document.createElement("input");
  input.value = link;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
  showToast("链接已复制");
};

const reservationStatus = ref(false);
const isLogin = computed(() => {
  return getToken();
});
const userImgUrl = getHeadImg();
const appointment = () => {
  homeOnOfficialMediaAppointClickReporting();
  if (!isLogin.value) {
    login();
  } else {
    showOrder.value = true;
  }
};

// 查询预约状态
const getReservationStatus = async () => {
  try {
    const res = await getReservation();
    reservationStatus.value = res.result;
  } catch (error) {
    reservationStatus.value = false;
  }
};

const login = () => {
  if (isInQQWork()) {
    openQqLogin();
  } else if (isInWeChatWork()) {
    openWxLogin();
  } else {
    showLogin.value = true;
  }
};
const logout = () => {
  removeToken();
};
const generateQR = async () => {
  try {
    qrImage.value = await generateQRCode(webUrl);
  } catch (error) {
    console.error("生成失败", error);
  }
};
onMounted(() => {
  generateQR();
  if (isLogin.value) {
    getReservationStatus();
  }
});
</script>

<style lang="scss" scoped>
@use "./m" as m;
</style>
